export function generateVCard(data) {
  const nameParts = data.name.split(" ");
  const firstName = nameParts[0] || "";
  const lastName = nameParts.slice(1).join(" ") || "";

  const vcard = `BEGIN:VCARD
VERSION:3.0
N:${lastName};${firstName};;;
FN:${data.name}
ORG:${data.company}
TITLE:${data.position}
TEL;TYPE=WORK,VOICE:${data.phone}
EMAIL;TYPE=WORK,INTERNET:${data.email}
URL:${data.website}
ADR;TYPE=WORK:;;${data.address.replace(/,/g, '\\,')}
END:VCARD`;

  const blob = new Blob([vcard], { type: "text/vcard" });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement("a");
  link.href = url;
  link.download = `${data.name.replace(/\s+/g, "_")}.vcf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
